
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { useCartWishlist } from '@/context/CartWishlistContext';

const AuthCallback = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { checkAuth } = useCartWishlist();

  useEffect(() => {
    handleAuthCallback();
  }, []);

  const handleAuthCallback = async () => {
    try {
      // Check if there's an error from Google OAuth
      const error = searchParams.get('error');
      if (error) {
        toast.error('Authentication failed. Please try again.');
        navigate('/');
        return;
      }

      // The backend has already set the session cookie via the callback
      // Just need to update the frontend state
      const token = searchParams.get('token');
      if (token) {
        localStorage.setItem('session_token', token);
      }

      await checkAuth();
      
      toast.success('Successfully logged in!');
      
      // Redirect to home
      navigate('/', { replace: true });
      
    } catch (error) {
      console.error('Auth callback error:', error);
      toast.error('Authentication failed. Please try again.');
      navigate('/');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center" data-testid="auth-loading">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-red-600 mx-auto mb-4"></div>
          <p className="text-white text-lg">Authenticating...</p>
        </div>
      </div>
    );
  }

  return null;
};

export default AuthCallback;
